/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiMessageBindings } from '../../models/AaiMessageBindings';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends AaiMessageBindings
 * @author eric.wittmann@gmail.com
 */
export class Aai20MessageBindings extends AaiMessageBindings {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
Aai20MessageBindings["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20MessageBindings";
Aai20MessageBindings["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




